<div [formGroup]="homeAddressForm">
  <app-content-header text="Home Address"></app-content-header>

  <div class="mt-2">
    <div
      class="dropdown input-container"
      style="width: 100%;"
    >
      <span class="input-label">Country</span>
      <mat-form-field class="input">
        <mat-select
          title="country"
          formControlName="country"
          (selectionChange)="onCountryChange($event.value)"
        >
          <mat-option
            *ngFor="let country of countryList"
            [value]="country.abbreviation"
          >{{ country.fullName }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div
      class="input-container"
      style="width: 100%;"
    >
      <span class="input-label">Address Line 1</span>
      <input
        title="address1"
        type="text"
        class="input"
        formControlName="address1"
        autocomplete="address-line1"
      >
      <span
        *ngIf="f['address1'].touched && f['address1'].value === ''"
        class="error"
      >Please enter an address.</span>
    </div>

    <div
      class="input-container"
      style="width: 100%;"
    >
      <span class="input-label">Address Line 2</span>
      <input
        title="address2"
        type="text"
        class="input"
        formControlName="address2"
        autocomplete="address-line2"
      >
    </div>

    <div
      class="input-container"
      style="width: 100%;"
    >
      <span class="input-label">City</span>
      <input
        title="city"
        type="text"
        class="input"
        value="city"
        formControlName="city"
        autocomplete="address-level2"
      >
      <span
        *ngIf="f['city'].touched && f['city'].value === ''"
        class="error"
      >Please enter a city.</span>
    </div>

    <div class="row no-gutters">
      <div class="col-sm dropdown input-container state-container">
        <span class="input-label">{{ homeAddressForm.value.country === 'us' ? 'State' : 'Province' }}</span>
        <mat-form-field class="input">
          <mat-select
            title="state"
            formControlName="stateProvince"
            [compareWith]="compareFn"
          >
            <mat-option
              *ngFor="let state of stateProvinceList"
              [value]="state.abbreviation"
              autocomplete="address-level1"
            >{{state.fullName}}</mat-option>
          </mat-select>
        </mat-form-field>
        <span
          *ngIf="f['stateProvince'].touched && f['stateProvince'].value === '' || f['stateProvince'].dirty && f['stateProvince'].value === ''"
          class="error"
        >Please select a {{ homeAddressForm.value.country === 'us' ? 'state' : 'province' }}.</span>
      </div>

      <div class="col-sm input-container">
        <span class="input-label">{{ homeAddressForm.value.country === 'us' ? 'ZIP Code' : 'Postal Code' }}</span>
        <input
          title="zipcode"
          class="input"
          type="text"
          formControlName="postalCode"
          autocomplete="postal-code"
        >
        <span
          *ngIf="f['postalCode'].touched && f['postalCode'].value === ''"
          class="error"
        >Please enter a {{ homeAddressForm.value.country === 'us' ? 'ZIP code' : 'postal code' }}.</span>
        <span
          *ngIf="f['postalCode'].dirty && homeAddressForm.hasError('postalCode') && f['postalCode'].value !== ''"
          class="error"
        >Invalid ZIP or Postal Code format.</span>
      </div>
    </div>
  </div>
</div>